module.exports = __webpack_public_path__ + "templates.delivery-section-fd1cefc5.html";